import styles from './skeletons.module.scss'

export default function MessageBoxSkeleton() {
  return (
    <div className={styles.messageBoxSkeleton}>
      <div className={styles.header}>消息通知</div>
      <div className={styles.contentSkeleton}>
        <div className={styles.contentRow}>
          <div className={styles.shortTextSkeleton}></div>
        </div>
        {Array.from({ length: 5 }).flatMap((_, index) => [
          <div
            key={`long-${index}-1`}
            className={styles.longTextSkeleton}
          ></div>,
          <div
            key={`long-${index}-2`}
            className={styles.longTextSkeleton}
          ></div>,
          <div
            key={`short-${index}`}
            className={styles.shortTextSkeleton}
          ></div>,
        ])}
      </div>
    </div>
  )
}
import styles from './skeletons.module.scss'

export default function MessageBoxSkeleton() {
  return (
    <div className={styles.messageBoxSkeleton}>
      <div className={styles.header}>消息通知</div>
      <div className={styles.contentSkeleton}>
        <div className={styles.contentRow}>
          <div className={styles.shortTextSkeleton}></div>
        </div>
        {Array.from({ length: 5 }).flatMap((_, index) => [
          <div
            key={`long-${index}-1`}
            className={styles.longTextSkeleton}
          ></div>,
          <div
            key={`long-${index}-2`}
            className={styles.longTextSkeleton}
          ></div>,
          <div
            key={`short-${index}`}
            className={styles.shortTextSkeleton}
          ></div>,
        ])}
      </div>
    </div>
  )
}
